﻿import React from 'react';
import styled from 'styled-components';
import control from '../../../vendor/react-validation/hocs/control';

const HiddenInput = ({ error, isChanged, isUsed, ...props }) => {
    return (
        <HiddenInputWrapper>
            <input type="hidden" {...props} {...( isChanged && isUsed && error ? {
                className: `is-invalid-input ${props.className}`
            } : { className: props.className } )} />
            {isChanged && isUsed && error}
        </HiddenInputWrapper>
    );
}

const HiddenInputWrapper = styled.span`
    display: none; 
`;

export default control(HiddenInput);